import { c as _c } from "react/compiler-runtime";
import { ActionWorldCardSkeleton } from '@/components/ActionWorldCard';
const UserFeaturedRoomsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex gap-4 md:-mx-2 md:gap-6 lg:gap-2">{Array.from({
        length: 4
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default UserFeaturedRoomsSkeleton;
function _temp(_, index) {
  return <ActionWorldCardSkeleton key={index} className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" />;
}